import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import './AboutMe.modules.css'
import Card from '../../components/Acad-card/Card';
import ExpCard from '../../components/Experiences-card/Card'
function AboutMe() {
    const myPhotoSRC = 'my.enc';
    const text = "Hi! I'm Santhosh";
    const [tags, setTags] = useState([]);
    var [i, setI] = useState(1);
    var typeInterval;
    const type = () => {
        typeInterval = !typeInterval && setInterval(() => {
            console.log(i);
            setI(j => j + 1);
        }, 100)
        if (i === text.length) {
            setTimeout(() => {
                setTags(['Learner', 'Tech-Enthusiast', 'Explorer', '|'])
            }, 500)
            clearInterval(typeInterval);
        }
    }
    const acads = [
        {
            title:"National Institute of Technology, Trichy — BTech",
            duration:"2020 - Present",
            score:"CGPA - 8.44"
        }
    ]
    const experiences = [
            {
                title:"Oracle, India—  Project Intern",
                duration:"May 2023 - July 2023",
                description:"As a project intern at Oracle, I worked on functional UI components and integrated them with the Data Exchange application of the Oracle Fusion Cloud Enterprise Performance Management suite."
            },
            {
                title:"Spider R&D Club, NIT Trichy— Co-President",
                duration:"August 2021 - Present",
                description:"I worked on multiple campus development and club projects in the Software domain. I work primarily with the application development, the server, and the DevOps teams. I was also a part of various workshops and events conducted by the club."
            },
            {
                title:"Pinch, Remote— Summer Intern",
                duration:"May 2022 - July 2022",
                description:"As a MERN stack developer intern at Pinch Finance, I worked with the Front-end team to build a mobile application using React Native. It uses Firebase SMS authentication, Cashfree for payment gateways, and socket.io for notifying users from the backend."
            },
    ]
    useEffect(() => {
        type();
        return () => clearInterval(typeInterval);
    }, [i])

    return (
        <div className='aboutme'>
            <nav>
                <a target='_blank' href='https://docs.google.com/document/d/18T22tU00YRDTogpg5JJb5Aa7P0bCZ29x9-Mox2rOitw/edit?usp=sharing'>
                    <button id="resume_btn">
                        Resume
                    </button>
                </a>
                <div className="arrows">
                    <Link to='/works'>
                        <span>Projects</span>
                        <i className="fas fa-chevron-right aboutMeR" ></i>
                    </Link>
                </div>
            </nav>
            <div className='mySelf'>
                <div className="image-container">
                    <img src={myPhotoSRC} loading='lazy'className='myPhoto' alt="SANTHOSH" />
                </div>
                <div className="tag-container">

                    <h1 id='name-intro'>
                        {text.slice(0, i)}
                    </h1>
                    <h3 id='tags'>
                        <span className='tag'>{tags[0]}</span>
                        <span> {tags[3]} </span>
                        <span className='tag'>{tags[1]}</span>
                        <span> {tags[3]} </span>
                        <span className='tag'>{tags[2]}</span>
                    </h3>
                </div>
            </div>
            
            <div style={{maxWidth: '1000px',margin: 'auto'}}>
                <h1 style={{marginTop:"20px"}}>
                    <b>
                        Experiences
                    </b>
                </h1>
                {
                    experiences.map(xp=>(
                        <ExpCard title={xp.title} duration={xp.duration} description={xp.description}/>
                    ))
                }
            </div>
            <div style={{maxWidth: '1000px',margin: 'auto', marginBottom:"100px", marginTop:"50px"}}>
                <h1 style={{marginTop:"20px"}}>
                    <b>
                        Education
                    </b>
                </h1>
                {
                    acads.map(acad=>(
                        <Card title={acad.title} duration={acad.duration} score={acad.score}/>
                    ))
                }
            </div>
        </div>

    )
}

export default AboutMe
